import { faCircleCheck, faCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { LinearProgressWithLabel } from '../../../../../account/AccountBoothProgressStepper';
import VyTooltip from '../../../../../common/VyTooltip';
import { CircularProgressWithLabel } from '../../UIComponents/ChallengeUiComponent';
import { useBooth } from '../../../../../../hooks/useBooth';
import { BoothProgressInterface, ProgressItem } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { useTranslation } from 'next-i18next';
import { faChevronDown, faInfo, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface BoothProgressProps {
  boothid: string;
}

export default function BoothProgress({ boothid }: BoothProgressProps) {
  const [showProgressDetail, setShowProgressDetail] = useState(false);
  const [progress, setProgress] = useState<BoothProgressInterface>();
  const booths = useSelector((state) => state.common.booths);

  const { getBoothProgress, focusProgressItem } = useBooth();
  const { t } = useTranslation();

  async function fetchProgress() {
    const _progress = await getBoothProgress(boothid);
    setProgress(_progress);
  }

  function isComplete(requiredItem: ProgressItem) {
    if (!progress) return false;
    return progress.completedItems.includes(requiredItem);
  }

  useEffect(() => {
    fetchProgress();
  }, [booths]);

  return (
    <div className="absolute z-50 transition-transform right-4 bottom-4">
      {!showProgressDetail ? (
        <VyTooltip title={t('booth:booth-progress')}>
          <div onClick={() => setShowProgressDetail(true)} className="flex items-center justify-center cursor-pointer">
            <CircularProgressWithLabel
              value={progress?.progress ?? 0}
              style={{ height: '65px', width: '65px', margin: '-20px' }}
              className={`bg-white border rounded-full shadow-md select-none`}
            />
          </div>
        </VyTooltip>
      ) : (
        <div className="flex flex-col gap-2 p-4 bg-white max-w-[90vw] border-slate-200 border rounded shadow-md text-slate-800">
          <div className="mb-4">
            <div className="flex justify-between gap-4">
              <p>
                {t('booth:booth-progress')}{' '}
                <VyTooltip title={t('booth:progress-tooltip')}>
                  <span>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </span>
                </VyTooltip>
              </p>
              <FontAwesomeIcon icon={faChevronDown} size="sm" onClick={() => setShowProgressDetail(false)} className="cursor-pointer" />
            </div>
            <LinearProgressWithLabel value={progress?.progress ?? 0} className="text-blue-500" />
          </div>

          {progress?.requiredItems.map((requiredItem) => {
            return (
              <p onClick={() => focusProgressItem(requiredItem)} className="cursor-pointer hover:text-slate-700" key={requiredItem.itemName}>
                <span className="mr-2">
                  {isComplete(requiredItem) ? <FontAwesomeIcon icon={faCircleCheck} color="green" /> : <FontAwesomeIcon icon={faCircle} color="red" />}
                </span>
                {requiredItem.translation}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
}
